// extracted by mini-css-extract-plugin
module.exports =  {"item":"_32bbee5fda--item--mrNt7"};